<template>
	<div class="container mt-3">
		<div class="gap-2 d-flex mb-3">
			<div class="btn btn-lg btn-primary flex-grow-1">Список</div>
			<router-link :to="{name: 'groups'}" class="btn btn-lg btn-outline-secondary flex-grow-1">Группы</router-link>
		</div>
		
		<div class="card mb-3" v-for="group in sortedGroups" :key="group.id" v-show="notCheckedSortedElems(group).length > 0">
			<div class="card-header bg-white">
				<router-link :to="{name: 'group-details', params: {id: group.id}}" class="text-decoration-none">
					<h5 class="text-break mb-0">{{group.name}}</h5>
				</router-link>
			</div>
			<div class="list-group list-group-flush">
				<div v-for="element in notCheckedSortedElems(group)" :key="element.id" class="list-group-item">
					<div class="form-check d-flex align-items-center">
						<input 
							type="checkbox" 
							class="form-check-input" 
							:id="'element-' + element.id"
							v-model="element.checked" 
							@change="onChangeChecked()"
							style="width: 30px; height: 30px; margin-right: 15px;" />
						<label class="form-check-label text-break w-100" :for="'element-' + element.id" style="font-size: 14px;">
							{{element.name}}
						</label>
					</div>
				</div>
			</div>
		</div>
		
		<div class="d-grid gap-2 mb-3 mt-3">
			<button class="btn btn-lg btn-outline-secondary" @click="checkedShow = !checkedShow">
				<span v-if="checkedShow">Скрыть купленные</span>
				<span v-else>Показать купленные</span>
			</button>
		</div>
		
		<div class="card mb-3" v-for="group in sortedGroups" :key="group.id" v-show="checkedShow && checkedSortedElems(group).length > 0">
			<div class="card-header bg-white">
				<router-link :to="{name: 'group-details', params: {id: group.id}}" class="text-decoration-none">
					<h5 class="text-break mb-0">{{group.name}}</h5>
				</router-link>
			</div>
			<div class="list-group list-group-flush">
				<div v-for="element in checkedSortedElems(group)" :key="element.id" class="list-group-item">
					<div class="form-check d-flex align-items-center">
						<input 
							type="checkbox" 
							class="form-check-input" 
							:id="'checked-element-' + element.id"
							v-model="element.checked" 
							@change="onChangeChecked()"
							style="width: 30px; height: 30px; margin-right: 15px;" />
						<label class="form-check-label text-break text-decoration-line-through w-100" :for="'checked-element-' + element.id" style="font-size: 14px;">
							{{element.name}}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import lib from '@/lib';

export default {
	name: "Lists",
	mixins: lib.mixins,
	data: () => ({
		checkedShow: false,
	}),
	computed: {
		sortedGroups(){
			return this.appModel.groups.sort(this.dynamicSort([
				{
					field: 'name',
					order: 'asc',
				}
			]));
		},
	},
	methods: {
		getPercent: lib.getPercent,
		
		dynamicSort(fields){
			return (a, b) => {
				for (let { field, order } of fields){
					if (a[field] !== b[field]){
						if(typeof(a[field]) === 'string'){
							return (order === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field]));
						} else {
							return (order === 'asc' ? a[field] - b[field] : b[field] - a[field]);
						}
					}
				}
				return 0;  // Если поля идентичны, объекты считаются равнозначными
			};
		},
		
		notCheckedSortedElems(group){
			return group.items.filter(element => !element.checked).sort(this.dynamicSort([
				{
					field: 'name',
					order: 'asc',
				}
			]));
		},
		checkedSortedElems(group){
			return group.items.filter(element => element.checked).sort(this.dynamicSort([
				{
					field: 'name',
					order: 'asc',
				}
			]));
		},
		
		onChangeChecked(){
			this.appModel.doElementCheckedToggle();
		},
	},
};
</script>
